<template>
	<v-card-text>
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">business_center</v-icon>
			<v-toolbar-title> {{ this.printTitle }}</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-btn v-if="editable && isSubsidiary" color="primary" class="mt-3 ml-3 white--text" dark
			@click="readOnlyMode = !readOnlyMode">
			<v-icon class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4">
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Polska nazwa</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="polishName"
						data-vv-as="Polska nazwa"
						:readonly="!canEditSubbidderNameFields"
						:error-messages="vErrors.collect('organizationNamesDataScope.polishName')"
						v-model="data.polishName"
						v-validate="'required'"
						data-vv-scope="organizationNamesDataScope"
						aria-label="label for polish name">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Angielska nazwa</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="englishName"
						data-vv-as="Angielska nazwa"
						:readonly="!canEditSubbidderNameFields"
						:error-messages="vErrors.collect('organizationNamesDataScope.englishName')"
						v-model="data.englishName"
						v-validate="'required'"
						data-vv-scope="organizationNamesDataScope"
						aria-label="label for english name">
					</v-text-field>
				</v-flex>
			</v-layout>
		</div>
	</v-card-text>
</template>

<script>
	export default {
		name: "OrganizationNamesProfileDataView",

		data () {
			return {
				readOnlyMode: true,

				data: {},
			};
		},

		watch: {
			organizationNamesData: function () {
				this.data = this.organizationNamesData;
			},

			readOnlyMode: function (value) {
				if (value) {
					this.$validator.validateAll("organizationNamesDataScope").then(result => {
						if (result) {
							this.$emit("edition-status", !value);
						} else {
							this.readOnlyMode = !this.readOnlyMode;
						}
					});
				} else {
					this.$emit("edition-status", !value);
				}
			}
		},

		computed: {
			icon() {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel() {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},

			canEditSubbidderNameFields() {
				return this.editable && !this.readOnlyMode && this.isSubsidiary;
			},

			printTitle() {
				if (this.title) {
					return this.title;
				}
				return 'Dane podmiotu';
			}
		},

		props: {
			organizationNamesData: Object,
			editable: {
				default: true,
			},
			isSubsidiary: Boolean,
			title: String

		}
	};
</script>

<style scoped>

</style>
